import { FC } from 'react';
import ChangeReferral from '../../components/change-referral';

const SubscriptionReferral: FC = () => {
	return <ChangeReferral />;
};

export default SubscriptionReferral;
